export default __webpack_public_path__ + "static/media/drawsAlreadyFunded.cde1217b.png";